module.exports = __webpack_public_path__ + "static/media/rajkhush-kumar-1.2801d12b.jpg";